export default "__VITE_ASSET__xz9sW0rQ__"